<template>
	<div id="footer">
		<div class="footernr">
			<div class="nrcontent">
				<div class="nrp">
					<p>版权所有：青岛纯晶稀有元素有限公司&nbsp; 2019 All Rights Reserved</p>
					<p>地址:青岛市即墨区通济街道办事处云桥村1038号 &nbsp;联系电话:0532-88531775</p>
					<p>技术支持:威海科迅信息科技有限公司</p>
					<p class="beian">网站备案号:<a href="http://www.beian.miit.gov.cn" 
					target="_blank" title="点击进入工信部网站首页" style="color:rgb(190,190,190) ;">鲁ICP备17000768号-2</a></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default{
	data(){
		return{
			
		}
	},
	created(){
		
	},
	methods:{
		
	},
}
</script>

<style scoped>
	#footer{
		width:100%;
		height:170px;
		background-color:#F9FBFF;
		border-top: 3px solid #16639f;
		margin-top:5px;
		position:relative;
	}
	.footernr{
		width: 1200px;
		height: 170px;
		margin:0 auto;

	}
	.nrcontent{
		width:800px;
		height: 170px;
		margin: 0 auto;
		position:absolute;
		left:50%;
		margin-left:-400px;
	}
	.nrcontent p{
		color:#333;
		font-size: 14.5px;
		line-height:2em;
		text-align: center;
	}
	.beian img{
		position:relative;
		top:3.6px;
	}
	.beian{
		color:rgb(190,190,190) !important;
	}
	.nrp{
		width:500px;
		height: 120px;
		margin:0 auto;
		margin-top:25px;
	}
</style>


// WEBPACK FOOTER //
// src/components/subcomponents/footer.vue